/* eslint-disable react/prop-types */
/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-console */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-array-index-key */
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import InputCheckbox from "Components/input-checkbox";
import { IconPlus, IconMinus, IconSearch } from "@tabler/icons";
import dynamic from "next/dynamic";

const OnSale = dynamic(() => import("Components/on-sale"),
	{ ssr: true });

const Price = dynamic(() => import("Components/price"),
	{ ssr: true });

const Desktop = ({
	title,
	filter,
	className,
	brandsMenu,
	productsMenu,
	handleFilterDesktop,
	handleFilterRemove,
}) => {

	const [show, setShow] = useState(false);
	const [allProducts, setAllProducts] = useState();
	const [allBrands, setAllBrands] = useState();
	const [brandSearch, setBrandSearch] = useState("");
	const [expandBrand, setExpandBrand] = useState(false);
	const [showAllBrands, setShowAllBrands] = useState(false);

	const toggleShow = (id) => {

		setShow(show === id ? false : id);

	};

	useEffect(() => {

		if (productsMenu !== undefined && allProducts === undefined) {

			setAllProducts(productsMenu);

		}

	}, [productsMenu]);

	useEffect(() => {

		if (brandsMenu !== undefined && allBrands === undefined) {

			setAllBrands(brandsMenu);

		} else {

			const updatedList = brandsMenu && brandsMenu.filter((item) => item?.name?.toLowerCase()?.includes(brandSearch.toLowerCase()));

			setAllBrands(updatedList);

		}

	}, [brandsMenu, brandSearch]);

	const FilterWrapper = ({
		last,
		expand,
		children,
		setExpand,
		titleFilter,
	}) => (
		<div
			className="filter-submenu"
			style={{ borderBottom: last ? "none" : "1px solid #DFE3E8" }}
		>
			<div className="filter-title">
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
						cursor: setExpand ? "pointer" : "default",
					}}
					onClick={setExpand}
				>
					<span className="side-menu-title">{titleFilter}</span>
					{expand !== undefined && setExpand !== undefined ? (
						<>
							{expand ? (
								<IconMinus stroke="1" size="20px" />
							) : (
								<IconPlus stroke="1" size="20px" />
							)}
						</>
					) : null}
				</div>
			</div>
			<div className="side-menu-submenu">
				{children}
			</div>
		</div>
	);

	// const

	return (
		<div className={`${className} side-menu`}>
			{/* Side Menu Browse Category */}
			{allProducts && allProducts.length > 0 && (
				<div
					style={{
						borderBottom: "1px solid #DFE3E8",
					}}
				>
					<span className="side-menu-title">
						BROWSE
						{" "}
						{title}
					</span>
					{allProducts
						&& allProducts.map((item) => {

							const childItems = item?.items;
							const isChildAvailable = childItems?.length > 0;
							const catSlug = item?.slug?.split("/");
							const slug = catSlug && catSlug[catSlug.length - 1];

							return (
								<div key={item.id} className="side-menu-submenu">
									<div
										className={
											`side-menu-text submenu-title
											${childItems?.filter((element) => filter.category.includes(element.category_slug)).length > 0
												|| filter.category.includes(slug)
												|| (item?.name?.toLowerCase() === title && !isChildAvailable) ? "selected" : ""}`
										}
										onClick={() => {

											if (isChildAvailable) {

												toggleShow(item.id);

											} else if (!filter.category.includes(slug)
											&& !(item?.name?.toLowerCase() === title && !isChildAvailable)) {

												handleFilterDesktop("category", slug);

											} else {

												handleFilterRemove("category", slug);

											}

										}}
									>
										<span>{item.name}</span>
										{
											isChildAvailable && (
												<>
													{show === item.id ? (
														<IconMinus stroke="1" size="20px" />
													) : (
														<IconPlus stroke="1" size="20px" />
													)}
												</>
											)
										}
									</div>
									{show === item.id ? (
										<div
											style={{
												display: "flex",
												flexDirection: "column",
												justifyContent: "space-between",
												margin: "10px 0 0 16px",
											}}
										>
											{childItems?.map((childItem) => {

												const categorySlug = childItem?.slug?.split("/");
												const childSlug = categorySlug && categorySlug[categorySlug.length - 1];

												return (
													<span
														key={childItem.entity_id}
														onClick={() => {

															if (!filter.category.includes(childSlug)) {

																handleFilterDesktop("category", childSlug);

															} else {

																handleFilterRemove("category", childSlug);

															}

														}}
														className={
															filter.category.includes(childItem) || filter.category.includes(childSlug)
																? "side-menu-text submenu-products selected"
																: "side-menu-text submenu-products"
														}
													>
														{childItem.name}
													</span>
												);

											})}
										</div>
									) : null}
								</div>
							);

						})}
				</div>
			)}
			{/* Side Menu Filter */}
			<div
				style={{
					marginTop: "18px",
				}}
			>
				<span
					style={{
						fontStyle: "normal",
						fontWeight: "600",
						fontSize: "12px",
						lineHeight: "100%",
						color: "#637381",
					}}
				>
					FILTER BY
				</span>
				{/* Filter By Brand */}
				{/* {brandsMenu && brandsMenu.length > 0 && (
					<FilterWrapper
						expand={expandBrand}
						titleFilter="BRAND"
						setExpand={() => setExpandBrand(!expandBrand)}
					>
						{expandBrand ? (
							<>
								<div className="search-brand">
									<input
										type="text"
										placeholder="Search Brand"
										value={brandSearch}
										onChange={(e) => handleSearchBrand(e.target.value)}
									/>
									<IconSearch />
								</div>
								<div className="brand-select">
									{allBrands?.length < 5 ? (
										allBrands.map((item, idx) => (
											<InputCheckbox
												key={String(idx)}
												onClick={() => {

													if (!filter.brand.includes(item.id)) {

														handleFilterDesktop("brand", item.id);

													} else {

														handleFilterRemove("brand", item.id);

													}

												}}
												title={item.name}
												isSelected={filter.brand.includes(item.id)}
											/>
										))
									) : (
										<>
											{allBrands.slice(0, 5).map((item, idx) => (
												<InputCheckbox
													key={String(idx)}
													onClick={() => {

														if (!filter.brand.includes(item.id)) {

															handleFilterDesktop("brand", item.id);

														} else {

															handleFilterRemove("brand", item.id);

														}

													}}
													title={item.name}
													isSelected={filter.brand.includes(item.id)}
												/>
											))}
											{showAllBrands ? (
												allBrands
													.slice(5, allBrands.length)
													.map((item, idx) => (
														<InputCheckbox
															key={String(idx)}
															onClick={() => {

																if (!filter.brand.includes(item.id)) {

																	handleFilterDesktop("brand", item.id);

																} else {

																	handleFilterRemove("brand", item.id);

																}

															}}
															title={item.name}
															isSelected={filter.brand.includes(item.id)}
														/>
													))
											) : (
												<span
													style={{
														fontSize: "14px",
														fontStyle: "normal",
														fontWeight: "400",
														lineHeight: "12px",
														letterSpacing: "0em",
														color: "#1B8884",
														cursor: "pointer",
													}}
													onClick={() => setShowAllBrands(!showAllBrands)}
												>
													See More +
													{allBrands.length - 5}
												</span>
											)}
										</>
									)}
								</div>
							</>
						) : null}
					</FilterWrapper>
				)} */}
				{brandsMenu && brandsMenu.length > 0 && (
					<div className="filter-submenu">
						<div className="filter-title">
							<div
								onClick={() => setExpandBrand(!expandBrand)}
								style={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
									cursor: "pointer",
								}}
							>
								<span className="side-menu-title">BRAND</span>
								{expandBrand ? (
									<IconMinus stroke="1" size="20px" />
								) : (
									<IconPlus stroke="1" size="20px" />
								)}
							</div>
						</div>
						{expandBrand ? (
							<>
								<div className="search-brand">
									<input type="text" placeholder="Search Brand" value={brandSearch} onChange={(e) => setBrandSearch(e.target.value)} />
									<IconSearch />
								</div>
								<div className="brand-select">
									{allBrands?.length < 5 ? (
										allBrands.map((item, idx) => (
											<InputCheckbox
												key={String(idx)}
												onClick={() => {

													if (!filter.brand.includes(item.id)) {

														handleFilterDesktop("brand", item.id);

													} else {

														handleFilterRemove("brand", item.id);

													}

												}}
												title={item.name}
												isSelected={filter.brand.includes(item.id)}
											/>
										))
									) : (
										<>
											{allBrands.slice(0, 5).map((item, idx) => (
												<InputCheckbox
													key={String(idx)}
													onClick={() => {

														if (!filter.brand.includes(item.id)) {

															handleFilterDesktop("brand", item.id);

														} else {

															handleFilterRemove("brand", item.id);

														}

													}}
													title={item.name}
													isSelected={filter.brand.includes(item.id)}
												/>
											))}
											{showAllBrands ? (
												allBrands
													.slice(5, allBrands.length)
													.map((item, idx) => (
														<InputCheckbox
															key={String(idx)}
															onClick={() => {

																if (!filter.brand.includes(item.id)) {

																	handleFilterDesktop("brand", item.id);

																} else {

																	handleFilterRemove("brand", item.id);

																}

															}}
															title={item.name}
															isSelected={filter.brand.includes(item.id)}
														/>
													))
											) : (
												<span
													style={{
														fontSize: "14px",
														fontStyle: "normal",
														fontWeight: "400",
														lineHeight: "12px",
														letterSpacing: "0em",
														color: "#1B8884",
														cursor: "pointer",
													}}
													onClick={() => setShowAllBrands(!showAllBrands)}
												>
													See More +
													{allBrands.length - 5}
												</span>
											)}
										</>
									)}
								</div>
							</>
						) : null}
					</div>
				)}
				{/* Filter By Category */}
				{/* {categoriesMenu && categoriesMenu.length > 0 && (
					<div className="filter-submenu">
						<div className="filter-title">
							<div
								onClick={() => setShowCategoryFilter(!showCategoryFilter)}
								style={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
									cursor: "pointer",
								}}
							>
								<span className="side-menu-title">Category</span>
								{showCategoryFilter ? (
									<IconMinus stroke="1" size="20px" />
								) : (
									<IconPlus stroke="1" size="20px" />
								)}
							</div>
						</div>
						{showCategoryFilter ? (
							<>
								<div className="brand-select">
									{categoriesMenu.length < 5 ? (
										categoriesMenu.map((item, idx) => (
											<InputCheckbox
												key={String(idx)}
												onClick={() => selectCategoryRating(item.id, "brand")}
												title={item.name}
												isSelected={item.selected}
											/>
										))
									) : (
										<>
											{categoriesMenu.slice(0, 5).map((item, idx) => (
												<InputCheckbox
													key={String(idx)}
													onClick={() => selectCategoryRating(
														item.id,
														"brand",
													)}
													title={item.name}
													isSelected={item.selected}
												/>
											))}
											{showAllCategories ? (
												categoriesMenu
													.slice(5, categoriesMenu.length)
													.map((item, idx) => (
														<InputCheckbox
															key={String(idx)}
															onClick={() => selectCategoryRating(
																item.id,
																"brand",
															)}
															title={item.name}
															isSelected={item.selected}
														/>
													))
											) : (
												<span
													style={{
														fontSize: "14px",
														fontStyle: "normal",
														fontWeight: "400",
														lineHeight: "12px",
														letterSpacing: "0em",
														color: "#1B8884",
														cursor: "pointer",
													}}
													onClick={() => setShowAllCategories(!showAllCategories)}
												>
													See More +
													{categoriesMenu.length - 5}
												</span>
											)}
										</>
									)}
								</div>
							</>
						) : null}
					</div>
				)} */}
				{/* Filter By Price */}
				{
					filter?.minPrice !== undefined
					&& filter?.maxPrice !== undefined
					&& (
						<FilterWrapper
							titleFilter="PRICE"
						>
							<Price
								valueMin={filter?.minPrice}
								valueMax={filter?.maxPrice}
								handleMin={(val) => handleFilterDesktop("minPrice", val, true)}
								handleMax={(val) => handleFilterDesktop("maxPrice", val, true)}
							/>
						</FilterWrapper>
					)
				}
				{/* Filter By Rating */}
				{/* <div
				className="filter-submenu"
				style={{
					borderBottom: "none",
					paddingBottom: "0",
				}}
			>
				<div className="filter-title">
					<div
						onClick={() => setShowRatingFilter(!showRatingFilter)}
						style={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							cursor: "pointer",

						}}
					>
						<span className="side-menu-title">
							RATING
						</span>
						{showRatingFilter
							? <IconMinus stroke="1" size="20px" />
							: <IconPlus stroke="1" size="20px" />}
					</div>
				</div>
				{showRatingFilter
					? (
						<div style={{
							marginTop: "15px",
							marginBottom: "-20px",
						}}
						>
							{ratingMenu.map((item) => (
								<div
									style={{
										display: "flex",
										alignItems: "center",
										margin: "10px 0",
									}}
									key={item.id}
								>
									<InputCheckbox
										title=""
										isSelected={item.selected}
										onClick={() => selectBrandRating(item.id, "rating")}
									/>
									<RatingStar
										type="1"
										rating={item.id}
									/>
								</div>
							))}
						</div>
					)
					: null}
			</div> */}
				{/* Filter By Sale */}
				{
					filter?.onSale !== undefined && (
						<FilterWrapper titleFilter="SALE" last>
							<OnSale
								title="SALE"
								isSelected={filter?.onSale}
								onSelected={() => handleFilterDesktop("onSale", !filter?.onSale, true)}
							/>
						</FilterWrapper>
					)
				}
			</div>
			<style>
				{`
				.side-menu{
					border: 1px solid #DFE3E8;
					box-sizing: border-box;
					padding: 24px;
					height: max-content;
				}

				.side-menu-submenu{
					margin: 18px 0;
				}

				.side-menu-title {
					font-size: 16px;
					font-style: normal;
					font-weight: 600;
					line-height: 24px;
					text-transform: uppercase;
				}

				.submenu-title {
					cursor: pointer;
					display: flex;
					align-items: center;
					justify-content: space-between;
				}

				.submenu-title.selected {
					cursor: pointer;
					display: flex;
					align-items: center;
					justify-content: space-between;
					font-weight: 900;
				}

				.side-menu-text {
					font-size: 14px;
					font-style: normal;
					font-weight: 400;
					line-height: 16px;
					letter-spacing: 0em;
				}

				.submenu-products {
					margin: 10px 0;
					cursor: pointer;
					color: #919EAB;
				}

				.submenu-products.selected {
					margin: 10px 0;
					cursor: pointer;
					font-weight: 600;
					color: #1A1E23;
				}

				.filter-submenu{
					margin: 20px 0;
					padding-bottom: 18px;
					border-bottom: 1px solid #DFE3E8;
				}

				.filter-title{
					font-size: 16px;
					font-style: normal;
					font-weight: 700;
					line-height: 16px;
					letter-spacing: 0em;
				}

				.search-brand {
					margin: 24px 0;
					display: flex;
					justify-content: center;
					align-items: center;
					border: 1px solid #DFE3E8;
					padding-right: 12px;
					border-radius: 2px;
				}

				.search-brand input {
					border: none;
					height: 40px;
					width: 100%;
					box-sizing: border-box;
					padding: 12px;
				}

				.brand-select{
					${showAllBrands && "height: 500px;"}
					overflow: -moz-scrollbars-vertical; 
					overflow-y: scroll;
				}

				.brand-select::-webkit-scrollbar {
					-webkit-appearance: none;
					width: 7px;
				}
				
				.brand-select::-webkit-scrollbar-thumb {
					border-radius: 4px;
					background-color: rgba(0, 0, 0, .5);
					-webkit-box-shadow: 0 0 1px rgba(255, 255, 255, .5);
				}

				.brand-select .container-checkbox-desktop {
					margin: 20px 0;
				}
				.category-select .container-checkbox-desktop {
					margin: 20px 0;
				}
				.submenu-flex {
					display: flex;
					justify-content: space-between;
				}
				.submenu-flex span{
					width: 48%;
				}
				.input-price {
					margin: 12px 0;
					display: flex;
					justify-content: center;
					align-items: center;
					border: 1px solid #DFE3E8;
					border-radius: 2px;
					width: 114px;
				}
				.input-price input {
					border: none;
					height: 40px;
					width: 100%;
					box-sizing: border-box;
					padding: 12px;
				}
				input:focus{
					outline: none;
				}
				p.error {
					margin: 4px 0;
					font-style: normal;
					font-size: 12px;
					line-height: 16px;
					color: #FF4D4F;
				}
				@media screen and (max-width: 1075px) {
					.submenu-flex {
						display: block;
					}
					.submenu-flex span{
						width: 100%;
					}
					.input-price {
						width: 100%;
					}
					.input-price input {
						height: 40px;
						width: 100%;
					}
				}
			`}
			</style>
		</div>
	);

};

Desktop.propTypes = {
	className: PropTypes.string,
	title: PropTypes.string,
	productsMenu: PropTypes.any,
	// setShowCategoryFilter: PropTypes.func,
	// setShowAllBrands: PropTypes.func,
	// setShowAllCategories: PropTypes.func,
	// showCategoryFilter: PropTypes.bool,
	// showAllBrands: PropTypes.bool,
	// showAllCategories: PropTypes.bool,
	brandsMenu: PropTypes.array,
	// categoriesMenu: PropTypes.array,
	// selectCategoryRating: PropTypes.func,
	filter: PropTypes.any.isRequired,
	handleFilterDesktop: PropTypes.func.isRequired,
	handleFilterRemove: PropTypes.func.isRequired,
};

export default Desktop;
